/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
// import styled from "styled-components"
import { FaFacebook, FaTwitterSquare } from "react-icons/fa";
import './bio.css'


import { rhythm } from "../utils/typography"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div className="container">
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                minWidth: 50,
                borderRadius: `100%`,
              }}
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
            <div>
            <p>
              一個想要脫離為別人工作的人生的工程師
              <br/>
              Social:
              <a href={social.twitter} target="_blank" rel="noopener noreferrer"><FaTwitterSquare/></a>
              <a href={social.facebook} target="_blank" rel="noopener noreferrer"><FaFacebook/></a>
              Support me:
              <a href={social.kofi} target="_blank" rel="noopener noreferrer">kofi</a>
            </p>
            
            </div>
            
          </div>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.png/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
          facebook
          kofi
        }
      }
    }
  }
`

// const Container = styled.div`
//   display: flex;
// `

export default Bio
